import { loadAllBasicInfo, loadSpecificBasicInfo } from '@/api/cache'
import lodash from 'lodash'
import { basicCacheKeys as cacheKeys, localCacheDatas } from './cacheConfig'
import { cache } from './cacheManager'
import { METHOD_PARAMS_KEY_COMPANY_LOB } from '@/class/cargo/model/parameters/SystemConstants'
export { cacheKeys }
/**
 * 基本数据的缓存定义
 */
/**
 * 本地数据的缓存控件
 * @type {Map<any, any>}
 */
const localDataCacheMap = new Map()

export const localCacheConfig = {

}

/**
 * 根据字段值解析为转换后的值
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param refreshCache
 * @returns {Promise<[]>}
 */
export function resolveLocalCacheSpecificField2Value(cacheKey, sourceField = '', sourceValue, targetField) {
  let result = []
  if (Object.prototype.hasOwnProperty.call(localCacheDatas, cacheKey)) {
    result = Array.from(localCacheDatas[cacheKey])
  }

  // console.log('sourceValue', sourceValue, sourceField, targetField)
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(commonState => {
      return commonState[sourceField] === sourceValue
    })
    if (entity) {
      targetValue = entity[targetField] || ''
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return targetValue
}

/**
 * 根据字段值解析为转换后的值（忽略大小写）
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param isNeedObject
 * @param compareFirstPart
 * @returns {Promise<[]>}
 */
export function resolveLocalCacheSpecificField2ValueIgnoreCase(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject = false, compareFirstPart = false, methodParams) {
  if (typeof sourceValue === 'string') {
    sourceValue = sourceValue.toUpperCase()
  }
  let result = []
  if (Object.prototype.hasOwnProperty.call(localCacheDatas, cacheKey)) {
    result = Array.from(localCacheDatas[cacheKey])
    if (result && methodParams) {
      result = result.filter(item => {
        // 遍历 methodParams 对象中的每一个键值对
        return Object.keys(methodParams).every(key => {
          if (key === METHOD_PARAMS_KEY_COMPANY_LOB.code) {
            return item[methodParams[key]] === true
          }
          return item[key] === methodParams[key]
        })
      })
    }
  }

  // console.log('sourceValue', sourceValue, sourceField, targetField)
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(commonState => {
      if (typeof sourceValue === 'string' && typeof commonState[sourceField] === 'string') {
        let value = commonState[sourceField]
        if (value && compareFirstPart) {
          value = value.split(',')[0]
        }
        return value.toUpperCase() === sourceValue
      }
      return commonState[sourceField] === sourceValue
    })
    if (entity) {
      targetValue = entity[targetField] || ''
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return targetValue
}

